import React, { useEffect } from 'react';
import cx from 'classnames';
import ReactTooltip from 'react-tooltip';
import { NavLink, useRouteMatch } from 'react-router-dom';
import { FormattedPlural } from 'react-intl';
import { PalletsCell, WeightCell, HeightCell, DistanceCell } from 'utils/format';
import { StopCell } from 'modules/fleet/list';
import VehicleImage from 'components/VehicleImage';

import ReasonsCell from 'modules/job-review/reasons-cell';
import { ServiceTagFleetService, ServiceTagFTC } from 'components/ServiceTag';

const t = {
  job: 'job',
  jobs: 'jobs',
};

const cellWidth = (minWidth, maxWidth) => ({
  style: {
    minWidth: minWidth,
    maxWidth: maxWidth ? maxWidth : minWidth,
    flex: 1,
  },
});

const Ghost = (props) => <div {...props} />;

const JobReviewListItem = ({ className, reduced, loading, to, driverDay }) => {
  const BaseComponent = driverDay && to ? NavLink : Ghost;
  const match = useRouteMatch(to);

  useEffect(() => {
    ReactTooltip.rebuild();
  });

  return (
    <BaseComponent
      to={to}
      className={cx(className, {
        [`${className}__loading`]: loading,
      })}
      activeClassName="selected"
    >
      <div className="cell cell__dark cell__center" {...cellWidth('60px')}>
        <VehicleImage type={driverDay?.vehicle_type} color={match ? 'white' : 'grey700'} />
      </div>
      <div className="cell cell__nowrap cell__dark" {...cellWidth('100px', '300px')}>
        {driverDay?.driver?.contact_name}
        {driverDay?.driver?.is_ftc && (
          <>
            &nbsp;
            <ServiceTagFTC />
          </>
        )}
        {driverDay?.driver?.is_fleet_service && (
          <>
            &nbsp;
            <ServiceTagFleetService />
          </>
        )}
      </div>
      <div className="cell cell__center" {...cellWidth('65px')}>
        {!!driverDay?.number_of_journeys && (
          <>
            {driverDay?.number_of_journeys}&nbsp;
            <FormattedPlural value={driverDay?.number_of_journeys} one={t.job} other={t.jobs} />
          </>
        )}
      </div>

      {!reduced && (
        <StopCell
          label={driverDay?.start_label}
          timeFrom={driverDay?.start_time_from}
          timeTo={driverDay?.start_time_to}
          {...cellWidth('100px', '136px')}
        />
      )}

      {!reduced && (
        <div className="cell cell__center" {...cellWidth('64px')}>
          <DistanceCell
            distance={driverDay?.distance}
            distanceMiles={driverDay?.distance_miles}
            country={driverDay?.route?.country}
          />
        </div>
      )}

      {!reduced && (
        <StopCell
          label={driverDay?.end_label}
          timeFrom={driverDay?.end_time_from}
          timeTo={driverDay?.end_time_to}
          firstStopTimeFrom={driverDay?.start_time_from}
          {...cellWidth('100px', '136px')}
        />
      )}

      {!reduced && (
        <div className="cell cell__bold cell__right cell__dark" {...cellWidth('96px')}>
          <PalletsCell
            realPallets={driverDay?.real_pallets}
            equivalentPallets={driverDay?.equivalent_pallets}
            typePallets={driverDay?.type_pallets}
            country={driverDay?.route?.country}
          />
        </div>
      )}
      {!reduced && (
        <div className="cell cell__right cell__dark" {...cellWidth('72px')}>
          <WeightCell weight={driverDay?.total_weight} />
        </div>
      )}
      {!reduced && (
        <div className="cell cell__right cell__dark" {...cellWidth('56px')}>
          <HeightCell height={driverDay?.item_height} />
        </div>
      )}
      {!reduced && (
        <ReasonsCell
          className="cell cell__grow cell__hidden_overflow"
          reasons={driverDay?.reasons}
          id={driverDay?.id}
        />
      )}
    </BaseComponent>
  );
};

export default JobReviewListItem;
